import { useState, useEffect } from 'react';
import { Play, Flame } from 'lucide-react';
import { ContentRail } from './ContentRail';
import { formatDuration } from '../../utils/homeHelpers';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function PopularThisWeekSection({ navigate, onPlayVideo }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetch(`${API}/content/popular-this-week?limit=15`)
      .then(r => r.json())
      .then(data => setItems(data.items || []))
      .catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <ContentRail
      icon={<Flame className="w-5 h-5 text-orange-500 shrink-0" />}
      title="Popular This Week"
      subtitle="Most watched across AfroSports"
      seeAllPath="/highlights"
      navigate={navigate}
      testId="popular-this-week-section"
    >
      {items.map((item) => (
        <div
          key={item.id}
          onClick={() => {
            if (item.source === 'youtube' && item.youtube_video_id) onPlayVideo(item);
            else navigate(`/match/${item.id}`);
          }}
          className="flex-shrink-0 w-[260px] sm:w-[300px] cursor-pointer group snap-start"
          data-testid={`popular-card-${item.id}`}
        >
          <div className="relative aspect-video rounded-xl overflow-hidden mb-2.5">
            <img src={item.thumbnail_url} alt={item.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
            {item.competition_name && (
              <div className="absolute top-2 left-2 px-1.5 py-0.5 bg-black/60 backdrop-blur-sm border border-white/10 rounded-full">
                <span className="text-emerald-400 text-[8px] font-bold uppercase tracking-wider">{item.competition_name}</span>
              </div>
            )}
            {item.view_count > 0 && (
              <div className="absolute top-2 right-2 px-1.5 py-0.5 bg-orange-500/80 rounded-full">
                <span className="text-white text-[8px] font-bold">{item.view_count} views</span>
              </div>
            )}
            {item.duration && (
              <div className="absolute bottom-2 right-2 px-1.5 py-0.5 bg-black/80 text-white text-[9px] font-medium rounded">{formatDuration(item.duration)}</div>
            )}
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="w-11 h-11 bg-orange-500 rounded-full flex items-center justify-center shadow-lg shadow-orange-500/30">
                <Play className="w-4 h-4 text-white" fill="currentColor" />
              </div>
            </div>
          </div>
          <h3 className="text-white font-semibold text-sm group-hover:text-orange-400 transition-colors line-clamp-2">{item.teams || item.title}</h3>
          <p className="text-gray-500 text-xs mt-0.5 line-clamp-1">
            {item.duration ? formatDuration(item.duration) : ''}
            {item.competition_name ? ` \u00B7 ${item.competition_name}` : ''}
          </p>
        </div>
      ))}
    </ContentRail>
  );
}
